import { Link } from "react-router-dom";
import { estimatedCasePrice } from "@shared/guestPrice";

/** Kept outside product links so registration/sign-in are independent actions. */
export function GuestPrice({ estimate, basis, caseQuantity }: {
  estimate?: string | null;
  basis?: string | null;
  caseQuantity?: number | null;
}) {
  const valid = typeof estimate === "string" && /^\d+\.\d{2}$/.test(estimate) && Number(estimate) > 0;
  return (
    <div className="text-xs space-y-1 min-w-0">
      {valid ? <>
        <div className="font-semibold text-accent">Estimated price: ${estimate}{basis ? ` per ${basis}` : ""}</div>
        {caseQuantity && <div className="text-gray-600">Estimated case: ${estimatedCasePrice(estimate, caseQuantity)}</div>}
      </> : <div className="text-gray-600">Estimate unavailable</div>}
      <Link to="/register" className="block text-accent hover:underline">Sign up</Link>
      <Link to="/login" className="block text-gray-600 hover:underline">Sign in</Link>
    </div>
  );
}
